import * as React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { Heading, Button } from '@restworld/ui-ds-base';
import { useAnalytics } from '@restworld/utils-common';

import { useRedirectRoute } from '../form-inputs.hooks';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IWizardLastConfirmProps {}
export const WizardLastConfirm: React.FunctionComponent<IWizardLastConfirmProps> = () => {
  const router = useRouter();
  const { redirectUserCallback } = useRedirectRoute();
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();

  // The wizard is over. `questionnaire_progress` already says which step a worker reached and
  // where they stopped; what it never says is that somebody got to the end, because the last
  // step has no "continue" to fire it. Counted on this screen, which is the only thing a
  // finished questionnaire shows.
  React.useEffect(() => {
    trackEvent('worker_profile_completed', { source: 'application_wizard' });
  }, [trackEvent]);

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <CheckCircleIcon className="h-10 w-10 text-green-500 self-center" />
        <Heading size={3} align="center" weight="bold">
          {t('onboarding-page:we_saved_everything')}
        </Heading>
        <Heading size={5} align="center" color="muted" weight="normal">
          {t('onboarding-page:find_and_edit_information')}
        </Heading>
      </div>
      <div className="flex flex-col gap-4 w-full justify-center items-center">
        <Button
          fullwidth
          onClick={() => {
            trackEvent('worker_cta_clicked', { cta: 'understood', surface: 'profile_completed' });
            redirectUserCallback();
          }}
        >
          {t('common:i_understand')}
        </Button>
        <Button
          fullwidth
          variant="secondary-neutral"
          onClick={() => {
            trackEvent('worker_cta_clicked', { cta: 'go_to_profile', surface: 'profile_completed' });
            router?.push(`/profilo${router.query?.manage_using_klaaryo ? '?manage_using_klaaryo=true' : ''}`);
          }}
        >
          {t('common:go_to_profile')}
        </Button>
      </div>
    </div>
  );
};
export default WizardLastConfirm;
